export default __webpack_public_path__ + "static/media/36B32ED8-03B3-4BF1-9EA7-91853044C965.207a5ed5.jpeg";